// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-questionnaire-response-button .spinner{top:0;left:0}`, "",{"version":3,"sources":["webpack://./src/components/questionnaire_responses/DownloadQuestionnaireResponsesButton.vue"],"names":[],"mappings":"AAEE,iDACE,KAAA,CACA,MAAA","sourcesContent":["\n.download-questionnaire-response-button {\n  .spinner {\n    top: 0;\n    left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
